import { AlertOctagon } from "lucide-react";

/**
 * Full-width red banner shown whenever the running mode is LIVE
 * (frontend/CLAUDE.md: "LIVE mode must always render a red
 * full-width banner — never remove"). Rendered above every
 * dashboard page; absent in DEMO.
 */
export default function LiveBanner({ mode }: { mode: string | undefined }) {
  if (mode !== "LIVE") return null;
  return (
    <div
      className="live-banner animate-glow-pulse bg-live relative z-30 flex items-center justify-center gap-2 px-4 py-1.5 text-center text-sm font-bold tracking-wide text-white"
      role="alert"
      aria-label="Mode LIVE — trading réel"
    >
      <AlertOctagon className="size-4" aria-hidden />
      TRADING LIVE — argent réel en jeu
    </div>
  );
}
